import { render, staticRenderFns } from "./t_default_sort.vue?vue&type=template&id=f9cd92c2&"
import script from "./t_default_sort.vue?vue&type=script&lang=js&"
export * from "./t_default_sort.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports